import React, { CSSProperties, forwardRef, useImperativeHandle } from "react";

import { useIntl } from "react-intl";

import ChatAppointmentContent from "react-lib/apps/IsHealth/Chat/ChatAppointmentContent";
import ChatPostContent from "react-lib/apps/IsHealth/Chat/ChatPostContent";

import { handleNavigationMessage } from "../IsHealth/Chat/MessageContentHTML";

import ChatBox from "./ChatBox";

const IMAGES = {
  person: "/static/images/person.png",
};

type StaffChatBoxProps = {
  onEvent: (e: any) => any;
  chatController: any;
  apiToken: string;
  chatBoxStyle?: CSSProperties;
  divisionId: string;
  hideCallButton?: boolean;
  isChatPatientOnly?: boolean;
  menuSameLevelTextArea?: boolean;
  placeholder?: string;
  searchMessage?: {
    id: number;
    index: number;
    offset: number;
  };
  searchText?: string;
  selectedChat: any;
  toggleSearch?: boolean;
  userId: string;
  onClickLink: (e: MouseEvent) => void;
  onDidMount?: () => void;
  onOpenVideoCall?: (url: string, chatChannelId: string) => void;
  onPostMessage?: () => void;
  onSetChannelName?: (data: { name: string; division: number }) => void;
};

const StaffChatBox = forwardRef<any, StaffChatBoxProps>((props, ref) => {
  const intl = useIntl();

  const handleNavigationMessageCallback = (content: any) => {
    if (content.contentType === "patient_appointment" && props.isChatPatientOnly) {
      return (
        <ChatAppointmentContent
          onEvent={props.onEvent}
          author={content.author}
          contentPayload={content.contentPayload}
          userId={props.userId}
        />
      );
    } else if (content.contentType === "post") {
      return (
        <ChatPostContent
          onEvent={props.onEvent}
          // history={this.props.history}
          contentPayload={content.contentPayload}
          channelId={content.channelId}
          author={content.author}
          sendAt={content.sendAt}
          // chatName={this.state.chatName}
          // setProp={this.controller.setProp}
          messageId={content.messageId}
          onLoadImage={content.onLoadImage}
          history={undefined}
        />
      );
    }

    return handleNavigationMessage(content, intl);
  };

  const handleOpenVideoCallCallback = (url: string) => {
    props.onOpenVideoCall?.(url, props.selectedChat?.chat_channel_id);
  };

  return (
    <ChatBox
      ref={ref}
      controller={props.chatController}
      apiToken={props.apiToken}
      chatBoxStyle={props.chatBoxStyle}
      division_id={Number(props.divisionId)}
      fullname="fullname"
      hideCallButton={props.hideCallButton}
      icon={props.isChatPatientOnly ? props.selectedChat?.image || IMAGES.person : ""}
      isAdminView={props.isChatPatientOnly}
      isDateSeparator={props.isChatPatientOnly}
      isMediaViewer={props.isChatPatientOnly}
      isPatient={false}
      menuSameLevelTextArea={props.menuSameLevelTextArea}
      nullId={false}
      patientData={{}}
      placeholder={props.placeholder || intl.formatMessage({ id: "พิมพ์ข้อความที่ต้องการสนทนา" })}
      readOnly={false}
      searchMessage={props.searchMessage}
      searchText={props.searchText}
      showArchived={props.isChatPatientOnly}
      showFileSize={props.isChatPatientOnly}
      showMyMessageName={props.isChatPatientOnly}
      userId={props.userId}
      username="username"
      hideButtonMenu
      isStaff
      onClickLink={props.onClickLink}
      onDidMount={props.onDidMount}
      onNavigationMessage={handleNavigationMessageCallback}
      onOpenVideoCall={handleOpenVideoCallCallback}
      onPostMessage={props.onPostMessage}
      match={{
        params: {
          chatChannelId: props.selectedChat?.chat_channel_id,
        },
      }}
      messageViewStyle={{
        height: props.toggleSearch ? "75vh" : "80vh",
      }}
      onSetChannelName={props.onSetChannelName}
    />
  );
});

StaffChatBox.displayName = "StaffChatBox";

export default React.memo(StaffChatBox);
